import PropTypes from 'prop-types';

import getIcon from 'services/getIcon';

import classNames from 'classnames';

const SelectorButton = ({ bgColor, icon, isGreyed, isSelected, onSelectorChange, selector }) => (
  <button 
      className={classNames(
      "statuses-main-view-mobile__header__selectors__elements__button",
      { "statuses-main-view-mobile__header__selectors__elements__button--is-selected": isSelected },
      { "statuses-main-view-mobile__header__selectors__elements__button--is-greyed": isGreyed }
      )}
      onClick={() => onSelectorChange(selector)}
  >
    {getIcon({ bgColor, color: "white-base", icon, size: 24 })}
  </button>
)

SelectorButton.propTypes = {
  bgColor: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isGreyed: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelectorChange: PropTypes.func.isRequired,
  selector: PropTypes.string.isRequired
}

export default SelectorButton;
